import { createTheme } from '@mui/material/styles'

export const palette = {
  primary: {
    // light: will be calculated from palette.primary.main,
    main: '#d20a0a'
    // dark: will be calculated from palette.primary.main,
    // contrastText: will be calculated to contrast with palette.primary.main
  },
  secondary: {

    main: '#000000'

  },
  // Used by `getContrastText()` to maximize the contrast between
  // the background and the text.
  contrastThreshold: 3,
  // Used by the functions below to shift a color's luminance by approximately
  // two indexes within its tonal palette.
  // E.g., shift from Red 500 to Red 300 or Red 700.
  tonalOffset: 0.2
}

export const typography = {
  fontFamily: '"Lato", sans-serif',
  color: 'gray'
}

export const lightComponets = {
  // Name of the component
  MuiToolbar: {
    styleOverrides: {
      // Name of the slot
      root: {
        // Some CSS
        backgroundColor: '#fff'
      }
    }
  },
  MuiCard: {
    styleOverrides: {
      root: {
        padding: 15
      }
    }

  }

}

export const lightTheme = createTheme({
  mode: 'light',
  typography,
  palette: {
    ...palette,
    mode: 'light'
  },
  components: {
    ...lightComponets
  }
})

export const darkTheme = createTheme({
  mode: 'dark',
  typography,
  palette: {
    ...palette,
    mode: 'dark'
  }
})
